import { render, staticRenderFns } from "./NewElite.vue?vue&type=template&id=0f254cfe&"
import script from "./NewElite.vue?vue&type=script&lang=js&"
export * from "./NewElite.vue?vue&type=script&lang=js&"
import style0 from "./NewElite.vue?vue&type=style&index=0&id=0f254cfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports